import { Controller } from "@hotwired/stimulus";

// Template rows carry "__ROW__" in any attribute (ids, aria-controls, …) that needs a unique value.
const ROW_PLACEHOLDER = "__ROW__";

export default class extends Controller {
  static targets = ["list", "template"];
  static values = { nextIndex: Number };

  declare listTarget: HTMLElement;
  declare templateTarget: HTMLTemplateElement;
  declare nextIndexValue: number;

  add(): void {
    const row = this.templateTarget.content.cloneNode(true) as DocumentFragment;
    const index = String(this.nextIndexValue++);

    for (const element of row.querySelectorAll("*")) {
      for (const attribute of element.attributes) {
        if (attribute.value.includes(ROW_PLACEHOLDER)) {
          attribute.value = attribute.value.replaceAll(ROW_PLACEHOLDER, index);
        }
      }
    }

    this.listTarget.append(row);
  }

  remove(event: Event): void {
    (event.currentTarget as HTMLElement).closest("[data-row-list-row]")?.remove();
  }
}
